function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "24",
  height: "24",
  rx: "3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.876 5c.74.019 1.33.624 1.33 1.364l-.001.681h3.58a.511.511 0 010 1.023h-.882l-.563 8.96a2.08 2.08 0 01-2.073 1.95H9.03a2.08 2.08 0 01-2.046-1.95l-.59-8.96h-.883a.511.511 0 010-1.022l3.58-.001V6.33A1.364 1.364 0 0110.421 5h2.455zM7.448 8.068l.525 8.9c.036.556.499.989 1.057.988h5.237a1.064 1.064 0 001.057-.989l.552-8.864-8.428-.035zm6.246 1.705c.283 0 .511.23.511.512v5.455a.518.518 0 01-.51.511.518.518 0 01-.512-.511v-5.455c0-.283.229-.512.511-.512zm-4.091 0c.282 0 .511.23.511.512v5.455a.518.518 0 01-.511.511.518.518 0 01-.512-.511v-5.455c0-.283.23-.512.512-.512zm2.045 0c.283 0 .512.23.512.512v5.455a.518.518 0 01-.512.511.518.518 0 01-.511-.511v-5.455c0-.283.229-.512.511-.512zm1.228-3.716H10.42a.307.307 0 00-.307.307v.682h3.069v-.682a.307.307 0 00-.307-.307z",
  fill: "#D24667"
}))));